import { NodeCard, WORKLOAD_NAME, SERVICE_NODES } from "./internals";

export function IdentifyVisual() {
  return (
    <div className="grid min-h-[220px] items-center gap-4 sm:min-h-[260px] sm:grid-cols-[1fr_1.05fr] sm:gap-5">
      <div className="rounded-lg border border-dashed border-primary/35 bg-primary-tint/25 p-4 sm:p-5">
        <p className="mb-3 font-mono text-[12px] font-semibold uppercase tracking-[0.08em] text-primary sm:mb-4">
          Workload <span className="ml-1 normal-case tracking-normal text-foreground-muted">{WORKLOAD_NAME}</span>
        </p>
        <div className="grid gap-3">
          <NodeCard {...SERVICE_NODES.api} />
          <NodeCard {...SERVICE_NODES.lambda} />
          <NodeCard {...SERVICE_NODES.dynamo} tone="warning" />
        </div>
      </div>
      <div className="rounded-lg border border-[var(--warning)]/45 bg-surface p-4 shadow-md sm:p-5">
        <div className="flex items-center justify-between gap-3">
          <p className="font-mono text-[12px] font-semibold uppercase tracking-[0.08em] text-[var(--warning-text)]">
            Finding
          </p>
          <span className="rounded-sm border border-[var(--warning)]/40 bg-[var(--warning-bg)] px-2 py-1 text-[12px] font-semibold text-[var(--warning-text)]">
            Medium
          </span>
        </div>
        <h3 className="mt-4 text-lg font-semibold tracking-[-0.015em] text-foreground">
          Retention period missing
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-muted">
          DynamoDB table contains customer data without a configured retention policy.
        </p>
        <div className="mt-5 border-t border-border pt-4 text-sm text-foreground-muted">
          Connected to <span className="font-semibold text-foreground">{WORKLOAD_NAME}</span>
        </div>
      </div>
    </div>
  );
}
